if (!customElements.get('cart-recommendations-compact')) {
  class CartRecommendationsCompact extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.excludedIds = this.dataset.excludeProducts.split(',');
    }

    connectedCallback() {
      if (!this.productId) return;

      if (document. readyState === 'complete') {
        this.init();
        return;
      }
      
      window.addEventListener('load', () => {
        this.init();
      });
    }
    
    init() {
      window.FastSimonSDK.productRecommendation({
        productID: this.productId,
        specs:[
          {
            sources: ["related_purchase", "related_cart"],
            maxSuggestions: 10,
            widgetID: "custom-cart-upsell-widget-sparky",
          }
        ],
        callback: (response) => {
          const products = response?.payload?.[0]?.payload;     
          if (!products?.length) return;

          const nodeString = products.slice(0, 8)
            .map((product) => {
              if(product.tags?.includes("coming-soon")) {
                return;
              }
             return `
              <intersection-loader 
                data-product-id
                data-url="${product.u}" 
                data-section-id="product-tile-compact"
                class="aspect-auto h-12 loading relative flex items-center justify-center"
              >
                <div class="loader">
                  <span class="block w-12 h-12">
                    <svg class="animate-spin -ml-1 mr-3 h-full w-full text-accent1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  </span>
                </div>
              </intersection-loader>
            `});

          // insert product tiles into component, then unwrap the children into the slider
          nodeString.map((string) => {
            const div = document.createElement('div');
            div.classList.add('swiper-slide', '!hidden', 'has-[[data-product-id]]:!block');
            div.innerHTML = string;
            this.parentElement?.insertBefore(div, this);
          });
          
          this.parentElement.querySelectorAll('.swiper-slide')?.forEach((el, i) => {
            const observer = new MutationObserver(observerCallback);
            observer.observe(el, { childList: true, subtree: true });
            
            function observerCallback(mutationList, observer) {
              for (const mutation of mutationList) {
                if (mutation.type === 'childList') {
                  el.querySelectorAll('a[href][data-product-id]').forEach((link) => {
                    if (link?.getAttribute('data-position')) return;
                    
                    link.setAttribute('data-position', i);
                  })
                }
              }
            }
          });

          setTimeout(() => {
            this.remove();
          }, 500)
        }
      })
    }
  }

  customElements.define('cart-recommendations-compact', CartRecommendationsCompact);
}